import React from 'react'
import axios from 'axios'
import styled from 'styled-components/macro'
import { Redirect } from 'react-router-dom'
import { FormSection, PageTransition, Timeline } from 'components'
import pages from './pages'
import { furthestReachablePage } from 'lib/completeness'

const Wrapper = styled.div`
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
`

const RenderPage = ({ data, ...rest }) => (
	<FormSection>
		{data.title && <h2>{data.title}</h2>}
		<div>{data.Component && <data.Component {...rest} />}</div>
	</FormSection>
)

function App({ match, history }) {
	const applicationId = match.params.applicationId
	const [application, setApplication] = React.useState({ company: {} })
	const [, setFinnished] = React.useState(false)
	const [page, setPage] = React.useState(0)
	const [direction, setDirection] = React.useState(1)

	const totalPages = pages.length
	const reachable = furthestReachablePage(application)

	// Tallennetut tiedot haetaan uudelleen jokaisen vaiheen jälkeen, jotta
	// vaihe-esitys tietää, mitkä vaiheet on oikeasti täytetty.
	const refresh = () =>
		axios
			.get(`/api/applications/${applicationId}`)
			.then(res => setApplication(res.data))
			.catch(() => {})

	const handleMoveTo = p => {
		if (p > reachable) {
			return
		}
		setDirection(p > page ? 1 : -1)
		setPage(p)
	}

	const handleSubmit = () => {
		setFinnished(true)
	}

	const handleNext = () => {
		setDirection(1)
		if (page >= totalPages - 1) {
			handleSubmit()
			return
		}
		refresh()
		setPage(page => page + 1)
	}
	const handlePrev = () => {
		setDirection(-1)
		if (page > 0) {
			setPage(page - 1)
			return
		}

		history.replace('/')
	}

	const fetchData = c => {
		axios.get(`/api/applications/${c}`).then(res => {
			setApplication(res.data)
			// Palataan siihen vaiheeseen, johon tiedot riittävät.
			const max = furthestReachablePage(res.data)
			if (res.data.status === 'AUTHORIZER_ADDED') {
				setPage(Math.min(1, max))
			}
			if (res.data.status === 'STAKEHOLDERS_FILLED') {
				setPage(Math.min(2, max))
			}
			if (res.data.status === 'PAYMENT_REQUIRED') {
				setPage(Math.min(3, max))
			}
		})
	}

	React.useEffect(() => fetchData(applicationId), [applicationId])

	if (
		application.status === 'PAID' ||
		application.status === 'SIGNATURE_PENDING'
	) {
		return <Redirect to={`/form/${applicationId}/signing`} />
	}

	if (application.status === 'FINISHED') {
		return <Redirect to={`/form/${applicationId}/success`} />
	}

	return (
		<Wrapper>
			<Timeline
				page={page}
				pages={pages}
				totalPages={totalPages}
				moveTo={handleMoveTo}
				reachable={reachable}
			/>
			<div>
				<PageTransition page={page} direction={direction}>
					<RenderPage
						key={page}
						data={pages[page]}
						onNext={handleNext}
						application={application}
						setApplication={setApplication}
						page={page}
						totalPages={totalPages}
						onPrev={handlePrev}
						onMoveTo={handleMoveTo}
					/>
				</PageTransition>
			</div>
		</Wrapper>
	)
}

export default App
